import React, { useEffect } from "react";
import styles from "../ForPatientsSection/ForPatientsSection.module.css";
import { useNavigate } from "react-router-dom";
const ForPatientsSection = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "19647191",
          formId: "3c859198-28ca-4ce8-8cb2-8e9bd193c4c7",
          region: "na1",
          target: "#hubspotForm",
          css: "", // We'll override with our own styles
        });
      }
    };

    document.body.appendChild(script);

    // Custom styles for HubSpot form to match your design
    const style = document.createElement("style");
    style.innerHTML = `
      /* Container box */
      #hubspotForm {
        max-width: 900px;
        margin: 20px auto;
        border-radius: 12px;
       
        background: white;
      }

      /* Form labels */
      #hubspotForm label {
        color: #00758d !important;
        font-weight: 600 !important;
        display: block;
        margin-bottom: 6px;
        font-size: 17px;
        font-family: Open Sans;
      }

      /* Required star styling */
      #hubspotForm label .hs-error-msg, 
      #hubspotForm label > span.required {
        color: red !important;
        margin-left: 3px;
      }

      /* Input and textarea fields */
      #hubspotForm input[type="text"],
      #hubspotForm input[type="email"],
      #hubspotForm input[type="tel"],
      #hubspotForm input[type="number"],
      #hubspotForm select,
      #hubspotForm textarea {
        width: 100% !important;
        padding: 10px 15px !important;
        font-size: 16px !important;
        border: 1px solid #ddd !important;
        border-radius: 5px !important;
        background: #f8fafc !important;
        box-sizing: border-box;
        margin-bottom: 20px !important;
        resize: vertical;
        min-height:50px;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: normal;
        line-height: 22px;
      }

      /* Input focus */
      #hubspotForm input[type="text"]:focus,
      #hubspotForm input[type="email"]:focus,
      #hubspotForm textarea:focus {
        outline: none !important;
        border-color: #00a7e1 !important;
        background: white !important;
      }

      /* Submit button */
      #hubspotForm input[type="submit"] {
        background-color: #00758d !important;
        color: white !important;
        font-weight: 600 !important;
        border: none !important;
        padding: 12px 25px !important;
        border-radius: 5px !important;
        cursor: pointer !important;
        font-size: 16px !important;
        width: 120px !important;
        transition: background-color 0.3s ease;
      }

      #hubspotForm input[type="submit"]:hover {
        background-color: #00758d !important;
      }
        #hubspotForm .hs-form-required {
  color: red !important;
}

div[class^="ForPatientsSection_Hbspatientdiv"] a {
  color: #00a7e1 !important;
  font-weight: 600 !important;
  text-decoration: none !important;
}
    `;

    document.head.appendChild(style);
    const observer = new MutationObserver(() => {
      const container = document.querySelector(
        'div[class^="ForPatientsSection_Hbspatientdiv"]'
      );
      if (!container) return;

      const links = container.querySelectorAll("a");
      links.forEach((link) => {
        if (link.innerHTML.includes('"')) {
          link.innerHTML = link.innerHTML.replace(/"/g, "");
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      <div className={styles.BackBtnDiv}>
        <div className={styles.backBtn} onClick={() => navigate(-1)}>
          <svg
            width="18"
            height="15"
            viewBox="0 0 18 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.252011 8.20052L5.8383 14.6871C6.15713 15.0254 6.82754 15.1466 7.19124 14.759C7.55373 14.3848 7.55373 13.6604 7.19124 13.2729L3.08873 8.52662L17.0653 8.52662C17.5818 8.52662 18 8.06717 18 7.49988C18 6.9326 17.5817 6.47315 17.0653 6.47315L3.08873 6.47315L7.19 1.72555C7.55249 1.35132 7.57431 0.589615 7.19 0.239358C6.82751 -0.086909 6.16681 -0.098897 5.83706 0.323253L0.252011 6.79793C0.00955088 7.06428 -0.166247 7.75277 0.252011 8.1989V8.20052Z"
              fill="currentColor"
            />
          </svg>
          <h4>Back</h4>
        </div>
      </div>
      <div className={styles.containerBox}>
        <div className={styles.container}>
          <div className={styles.LeftSection}>
            <div className={styles.eyeforwarImg}>
              <img src="Images/Patients-img2.webp" alt="active couple gardening together" />
            </div>
          </div>
          <div className={styles.RightSection}>
            <div className={styles.Content}>
              <div className={styles.bredcrumMain} >

                <div className={styles.bredcrum}>
                  <h5 className={styles.Rightheading}>For Patients</h5>
                </div>

              </div>

              <h1 className={styles.title}>
                Welcome to a new era in comfort and clarity
              </h1>
              <h3 className={styles.subtitle}>
                At Bruno Vision Care, we advance vision science  that makes brilliant living
                possible
              </h3>

              <div className={styles.descriptions}>
                <p className={styles.dsec}>
                  Whether you’re new to contact lenses or have worn them for
                  years, our solutions are designed to bring clarity and comfort
                  to every pair of eyes. Soon, you’ll be able to connect with an
                  eye care professional near you who can introduce you to Bruno
                  Vision Care innovation.
                </p>
                <p className={styles.dsec}>
                  Want to be among the first to know more? Share your details
                  below, and we’ll keep you updated.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.HubSpotMain}>
          <div className={styles.Hbspatientdiv}>
            <div id="hubspotForm"></div>{" "}
          </div>
          <div className={styles.trackingDiv}>
            <img src="Images/class-img2.webp" alt="classroom of students studying reading materials at their desks" />
          </div>

          <div>
            <div id="hubspotForm"></div>{" "}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForPatientsSection;
